import { datadogLogs } from "@datadog/browser-logs";
import { light } from "@rscollabs/vue-cli-plugin-vuetify-preset-capsule-wardrobe/preset/theme";

import { env } from "./config";
import { getLoggingContext } from "./context";
import { Logger } from "./types";

// Top Left and Bottom Left rounded corners
const consoleBaseStyle = "padding:1px;";
const consoleFormatStart = `${consoleBaseStyle}border-radius:3px 0 0 3px;`;
const consoleFormatEnd = `${consoleBaseStyle}border-radius:0 3px 3px 0;`;
const consoleColorDark = `background:${light["secondary-60"]};color:#FFF;`;
const consoleColorLight = `background:${light["warm-grey-30"]};color:#000;`;

const consoleStyleSegments = [
  `${consoleFormatStart}${consoleColorDark}font-weight: bold;`,
  `${consoleBaseStyle}${consoleColorLight}`,
  `${consoleFormatEnd}${consoleColorLight}`,
];

const logger: Logger = (level, message) => {
  // Send Browser logs to DataDog
  if (env !== "local" && env !== "development") {
    const trace = getLoggingContext();
    datadogLogs.logger[level](message, Object.assign({}, trace));
  }

  if (env === "prod") {
    return;
  }

  console[level](`%c [LTK] %c ${message}%c `, ...consoleStyleSegments);
};

export default logger;
